import {AxiosPromise} from 'axios';
import {apiCaller} from '@/api/apiCaller';
import {neopvcHost} from '@/api/urls';

import {Project} from '@/modules/neopvc/models';
import {AuditEntry} from '@/modules/neopvc/models/auditEntry';
const baseUrl = '/api/pvc/project';

const getProjects = (): AxiosPromise<Project[]> =>
    apiCaller.get('/api/pvc/projects', neopvcHost);

const getAuditEntries = (): AxiosPromise<AuditEntry[]> =>
    apiCaller.get(`/api/pvc/audit/load`, neopvcHost);

const saveNewProject = (project: Project): AxiosPromise<void> =>
    apiCaller.post(baseUrl, neopvcHost, project);

const calculateProjectDestiny = (project: Project): AxiosPromise<void> =>
    apiCaller.post(`${baseUrl}/${project.id}/calculate/destiny`, neopvcHost, null);

const calculateProjectOrigin = (project: Project): AxiosPromise<void> =>
    apiCaller.post(`${baseUrl}/${project.id}/calculate/origin`, neopvcHost, null);

export const projectService = {
  getProjects,
  getAuditEntries,
  saveNewProject,
  calculateProjectDestiny,
  calculateProjectOrigin,
};
